import React from "react";
import * as SC from "./styled";

const Item = ({ data, hideTitle }) => (
  <SC.Container>
    {!hideTitle && <SC.Title>{data.name}</SC.Title>}
    <SC.HR />
    <SC.Description>{data.description}</SC.Description>
    <SC.HR />
    {data.submenu.map((item, i) =>
      item.target ? (
        <SC.ExternalLink key={i} href={item.url} target={item.target}>
          {item.name}
        </SC.ExternalLink>
      ) : (
        <SC.MenuLink key={i} to={item.url}>
          {item.name}
        </SC.MenuLink>
      )
    )}
  </SC.Container>
);

export default Item;
